import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function JoinPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      sessionStorage.setItem('olso_pending_ref', ref);
    }
    navigate('/', { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
